import React, { useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}

export default function PreJoinScreens() {
  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const { URLnombre } = useParams<{ URLnombre?: string }>();
  const [step, setStep] = useState(Steps.roomNameStep);

  const [name, setName] = useState<string>(user?.displayName || '');
  const [clave, setClave] = useState<string>('');
  const [roomName, setRoomName] = useState<string>('');
  const [nombreUsuario, setNombreUsuario] = useState<string>('');

  const [mediaError, setMediaError] = useState<Error>();

  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
      if (user?.displayName) {
        setStep(Steps.deviceSelectionStep);
      }
    }
    if (URLnombre) {
      setNombreUsuario(URLnombre);
    }
  }, [user, URLRoomName, URLnombre]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log('Error acquiring local media:');
        console.dir(error);
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!name.includes('-')) {
      const randomSuffix = Math.random().toString(36).substring(2, 4).toUpperCase();
      const newName = `${name}-${randomSuffix}`;
      setName(newName);
  
      setTimeout(() => {
        let currentURL = window.location.href;
        if (!currentURL.includes('usuario')) {
          window.history.replaceState(
            null,
            '',
            window.encodeURI(`/room/${roomName}${window.location.search || ''}`)
          );
        }
  
        setStep(Steps.deviceSelectionStep);
      }, 1000);
    } else {
      let currentURL = window.location.href;
      if (!currentURL.includes('usuario')) {
        window.history.replaceState(
          null,
          '',
          window.encodeURI(`/room/${roomName}${window.location.search || ''}`)
        );
      }
  
      setStep(Steps.deviceSelectionStep);
    }
    //event.preventDefault();
    
    // If this app is deployed as a twilio function, don't change the URL because routing isn't supported.
    // @ts-ignore
    //let currentURL = window.location.href;
    //if (currentURL.includes('usuario')) {
      //window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
    //} else {
      //window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
    //}
    /* if (!window.location.origin.includes('twil.io') && !window.STORYBOOK_ENV) {
      window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
    } */
    //setStep(Steps.deviceSelectionStep);
  };

  return (
    <IntroContainer>
      <MediaErrorSnackbar error={mediaError} />
      {step === Steps.roomNameStep && (
        <RoomNameScreen
          name={name}
          clave={clave}
          roomName={roomName}
          setName={setName}
          setClave={setClave}
          setRoomName={setRoomName}
          handleSubmit={handleSubmit}
          setNombreUsuario={setNombreUsuario}
        />
      )}

      {step === Steps.deviceSelectionStep && (
        <DeviceSelectionScreen name={name} roomName={roomName} setStep={setStep} clave={clave} />
      )}
    </IntroContainer>
  );
}
